import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2 flex flex-col gap-4">
          <Logo />
          <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
            樱桃视频是面向影迷的优质影视内容聚合与信息展示平台，汇集最新电影、电视剧与热门综艺，
            提供分类浏览、关键词搜索与作品详情查询，帮助你快速找到想看的内容。
          </p>
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-shield-check-line text-primary-500"></i>
            <span>本平台播放区域仅为演示，不含真实视频播放与下载</span>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <h3 className="font-heading font-bold text-foreground-950 text-sm tracking-wide">
            内容分类
          </h3>
          <Link to="/category/movie" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors w-fit cursor-pointer">
            最新电影
          </Link>
          <Link to="/category/tv" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors w-fit cursor-pointer">
            热播电视剧
          </Link>
          <Link to="/category/variety" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors w-fit cursor-pointer">
            热门综艺
          </Link>
          <Link to="/search" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors w-fit cursor-pointer">
            全站搜索
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          <h3 className="font-heading font-bold text-foreground-950 text-sm tracking-wide">
            关于与联系
          </h3>
          <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors w-fit cursor-pointer">
            关于我们
          </Link>
          <a
            href="mailto:support@cherryvideo.example"
            className="text-sm text-foreground-600 hover:text-primary-500 transition-colors w-fit cursor-pointer"
          >
            support@cherryvideo.example
          </a>
          <span className="text-sm text-foreground-600 flex items-center gap-2 w-fit">
            <i className="ri-customer-service-2-line"></i>400-000-2026
          </span>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 樱桃视频 Cherry Video. 保留所有权利。本网站为影视内容演示平台。
          </p>
          <p className="text-xs text-foreground-500">
            友情提示：请支持正版影视内容，拒绝盗版。
          </p>
        </div>
      </div>
    </footer>
  );
}